/**
 * FeatureToggleDemoPanel — C020 기능 토글 데모 (queue #646 §R646-2 항목10)
 * 토글 키 입력 → enabled(bool) + 출처 표시. read-only.
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFeatureToggleEvaluate } from '../../hooks/useFeatureToggleDemo';
import { cardStyle, sectionTitleStyle, subtitleStyle, labelStyle, inputStyle, monoStyle, primaryButtonStyle, resultBoxStyle, DemoErrorState, DemoEmptyHint } from './demoShared';

export function FeatureToggleDemoPanel() {
  const { t } = useTranslation();
  const evaluateMutation = useFeatureToggleEvaluate();
  const [key, setKey] = useState('showcase.demo.sample-toggle');

  return (
    <section aria-labelledby="feature-toggle-panel-title">
      <h2 id="feature-toggle-panel-title" style={sectionTitleStyle}>{t('showcase.demo.featureToggle.title')}</h2>
      <p style={subtitleStyle}>{t('showcase.demo.featureToggle.subtitle')}</p>

      <div style={cardStyle}>
        <div style={{ marginBottom: 'var(--spacing-4)' }}>
          <label htmlFor="feature-toggle-key" style={labelStyle}>{t('showcase.demo.featureToggle.keyLabel')}</label>
          <input id="feature-toggle-key" type="text" value={key} onChange={(e) => setKey(e.target.value)} style={inputStyle} />
        </div>

        <button
          type="button"
          onClick={() => evaluateMutation.mutate(key)}
          disabled={evaluateMutation.isPending || !key.trim()}
          aria-busy={evaluateMutation.isPending}
          style={{ ...primaryButtonStyle, opacity: evaluateMutation.isPending ? 0.6 : 1 }}
        >
          {evaluateMutation.isPending ? t('showcase.demo.featureToggle.evaluating') : t('showcase.demo.featureToggle.evaluateButton')}
        </button>

        <div style={{ marginTop: 'var(--spacing-4)' }}>
          {evaluateMutation.isError && (
            <DemoErrorState title={t('showcase.demo.common.callFailed')} error={evaluateMutation.error} />
          )}
          {!evaluateMutation.isError && !evaluateMutation.data && <DemoEmptyHint text={t('showcase.demo.featureToggle.empty')} />}
          {evaluateMutation.data && !evaluateMutation.isError && (
            <div role="region" aria-label={t('showcase.demo.featureToggle.resultLabel')} style={resultBoxStyle}>
              <dl style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 'var(--spacing-2) var(--spacing-4)', margin: 0, fontSize: 'var(--font-size-sm)' }}>
                <dt style={{ color: 'var(--color-text-muted)', fontWeight: 600 }}>{t('showcase.demo.featureToggle.enabledLabel')}</dt>
                <dd style={{ margin: 0, ...monoStyle, fontWeight: 700, color: evaluateMutation.data.enabled ? 'var(--color-status-success)' : 'var(--color-text-muted)' }}>
                  {evaluateMutation.data.enabled ? t('showcase.demo.common.yes') : t('showcase.demo.common.no')}
                </dd>
                <dt style={{ color: 'var(--color-text-muted)', fontWeight: 600 }}>{t('showcase.demo.featureToggle.sourceLabel')}</dt>
                <dd style={{ margin: 0, ...monoStyle }}>{evaluateMutation.data.source}</dd>
              </dl>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
